<template>
  <div class="chart-area">
    <div class="chart-detail-title d-sm-flex justify-content-between">
      <h2>時期別登録者状況</h2>
    </div><!-- ends chart-detail-title -->
    <div class="row">
      <div class="offset-lg-2 col-lg-4 col-md-6">
        <div class="chart-detail" v-if="data.monthly.length!=0">
          <div class="chart-display">
            <line-chart :chart-data="MonthlyDataSet" :options="options_monthly"/>
          </div><!-- ends chart-display -->
        </div><!-- chart-detail -->
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="chart-detail" v-if="data.weekly.length!=0">
          <div class="chart-display">
            <line-chart :chart-data="WeeklyDataSet" :options="options_weekly"/>
          </div><!-- ends chart-display -->
        </div><!-- chart-detail -->
      </div>

      <!-- <div class="col-lg-4">
        <div class="chart-detail" v-if="data.daily.length!=0">
          <div class="chart-display">
            <line-chart :chart-data="DailyDataSet" :options="options_daily"/>
          </div>
        </div>
      </div> -->
    </div>
  </div><!-- ends chart-area -->
</template>

<script>
import randomColor from 'randomcolor';
import LineChart from '@/components/dashboard/chart/LineChart.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'BarChart',
  components: { LineChart },
  data() {
    return {
      options_monthly: {
        responsive: true,
        legend: {
          display: true,
          labels: {
            fontSize: 16,
            fontStyle: 'bold',
          },
        },
        title: {
          display: true,
          fontSize: 16,
          fontStyle: 'bold',
          text: '登録者数　月次',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 16,
                fontStyle: 'bold',
                callback: (value, index, values) => {
                  if (Math.floor(value) === value) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      },
      options_weekly: {
        responsive: true,
        legend: {
          display: true,
          labels: {
            fontSize: 16,
            fontStyle: 'bold',
          },
        },
        title: {
          display: true,
          fontSize: 16,
          fontStyle: 'bold',
          text: '登録者数　週次',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 16,
                fontStyle: 'bold',
                callback: (value, index, values) => {
                  if (Math.floor(value) === value) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      },
      options_daily: {
        responsive: true,
        legend: {
          display: true,
          labels: {
            fontSize: 16,
            fontStyle: 'bold',
          },
        },
        title: {
          display: true,
          fontSize: 16,
          fontStyle: 'bold',
          text: '登録者数　日次',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 16,
                fontStyle: 'bold',
                beginAtZero: true,
                callback: (value, index, values) => {
                  if (Math.floor(value) === value) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      },
      data: {
        monthly: [],
        weekly: [],
        daily: [],
      },
    };
  },
  created() {
    this.load();
  },
  computed: {
    MonthlyDataSet() {
      // const dataSets =  [];
      // this.categories.forEach(category => {
      //   const color = randomColor({ luminosity: "bright" });
      //   if(category.count !== 0) {
      //     dataSets.push({
      //       label: category.title,
      //       borderColor: color,
      //       backgroundColor: color,
      //       fill: false,
      //       data: [category.count],
      //     });
      //   }
      // });
      // return {
      //   datasets:dataSets,
      // };
      const dataSets = [];
      this.data.monthly.forEach((datum) => {
        const color = randomColor({ luminosity: 'bright' });
        dataSets.push({
          label: datum.month,
          borderColor: color,
          backgroundColor: color,
          fill: false,
          data: [datum.count],
        });
      });
      return {
        datasets: dataSets,
      };
    },
    WeeklyDataSet() {
      const dataSets = [];
      this.data.weekly.forEach((datum) => {
        const color = randomColor({ luminosity: 'bright' });
        dataSets.push({
          label: datum.week,
          borderColor: color,
          backgroundColor: color,
          fill: false,
          data: [datum.count],
        });
      });
      return {
        datasets: dataSets,
      };
    },
    DailyDataSet() {
      const dataSets = [];
      this.data.daily.forEach((datum) => {
        const color = randomColor({ luminosity: 'bright' });
        dataSets.push({
          label: datum.day,
          borderColor: color,
          backgroundColor: color,
          fill: false,
          data: [datum.count],
        });
      });
      return {
        datasets: dataSets,
      };
    },
  },
  methods: {
    load() {
      const timezone = new Date().getTimezoneOffset();
      ApiService.get(Api.endpoints.MONTLY_CHART, {}, { timezone }).then(({ data }) => {
        this.data = data.data;
      }).catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>
<style scoped>
.ttt {
  display: flex;
  background-color: red;
}

.ttt > div {
  width: 30%;
}

.ttt .chart-detail {
  padding: 10px;
}

.ttt .chart-area {
  margin-right: 15px;
}

.ttt .chart-area:last-child {
  margin-right: 0;
}

.ttt canvas {
  width: 100%;
  min-width: 50px !important;
}
</style>

